jQuery(document).ready(function(){

	/* The function for the category badges */
	jQuery(".posts-category .category").each(function() {
		var textCat = jQuery(this).html();
		var sliceCat = textCat.substr(0, 3);
		var restCat = textCat.substr(3);
		var injectSpan = '<span class="badge">'+sliceCat+'</span>'+restCat;
		jQuery(this).html(injectSpan);
	});

	jQuery(".mobile-tribe-events-categories .category").each(function() {
		var textCat = jQuery(this).html();
		var sliceCat = textCat.substr(0, 3);
		var injectSpan = '<span class="badge">'+sliceCat+'</span>';
		jQuery(this).html(injectSpan);
	});

	jQuery(".tribe-events-categories .category").each(function() {
		var textCat = jQuery(this).html();
		var sliceCat = textCat.substr(0, 3);
		var restCat = textCat.substr(3);
		var injectSpan = '<span class="badge">'+sliceCat+'</span>'+restCat;
		jQuery(this).html(injectSpan);
	});

});